import { formatRelative } from 'date-fns';

export function RelativeDate({ date }: { date: string }) {
    const d = new Date(date);
    // An unparseable date must never take the whole view down with it
    // (formatRelative throws RangeError on Invalid Date).
    if (Number.isNaN(d.getTime())) return '—';
    return formatRelative(d, new Date());
}
